if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        // Keep clicks on images / nav / counter from triggering the
        // media-modal "click anywhere to close" behavior (bubble listener
        // added by ModalDialog). Capture phase fires first on this element.
        this.addEventListener(
          'pointerup',
          (event) => {
            if (event.target.closest('img[data-media-id], .pmm-nav, .pmm-counter')) event.stopPropagation();
          },
          true
        );
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.initSlider();
        this.showActiveMedia();
      }

      slider() {
        return this.querySelector('[role="document"]');
      }

      currentIndex() {
        const container = this.slider();
        return container.clientWidth ? Math.round(container.scrollLeft / container.clientWidth) : 0;
      }

      updateCounter() {
        const el = this.querySelector('.pmm-current');
        if (el) el.textContent = this.currentIndex() + 1;
      }

      clearZoom() {
        this.querySelectorAll('.pmm-zoomed').forEach((img) => img.classList.remove('pmm-zoomed'));
      }

      initSlider() {
        if (this.pmmInit) return;
        this.pmmInit = true;
        const container = this.slider();

        container.addEventListener(
          'scroll',
          () => {
            this.updateCounter();
          },
          { passive: true }
        );

        const page = (dir) => {
          this.clearZoom();
          const kids = Array.from(container.children);
          const target = Math.min(Math.max(this.currentIndex() + dir, 0), kids.length - 1);
          container.scrollTo({ left: kids[target].offsetLeft, behavior: 'auto' });
          this.updateCounter();
        };
        this.querySelector('.pmm-prev')?.addEventListener('click', () => page(-1));
        this.querySelector('.pmm-next')?.addEventListener('click', () => page(1));

        // Tap / click an image toggles zoom at the tapped point; second tap zooms back out.
        container.addEventListener('click', (event) => {
          const img = event.target.closest('img[data-media-id]');
          if (!img) return;
          if (img.classList.contains('pmm-zoomed')) {
            img.classList.remove('pmm-zoomed');
          } else {
            const rect = img.getBoundingClientRect();
            const x = ((event.clientX - rect.left) / rect.width) * 100;
            const y = ((event.clientY - rect.top) / rect.height) * 100;
            img.style.transformOrigin = `${x}% ${y}%`;
            img.classList.add('pmm-zoomed');
          }
        });
      }

      showActiveMedia() {
        this.clearZoom();
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.slider();
        const idx = Array.prototype.indexOf.call(container.children, activeMedia);
        requestAnimationFrame(() => {
          container.scrollLeft = Math.max(idx, 0) * container.clientWidth;
          this.updateCounter();
        });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
